/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/alertsMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a Alerts. */
export class Alerts {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a Alerts.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Alerts Manager to return all alerts for the current user and family based on the
   * parameters.
   * @summary Retrieves all alerts for for the current user and family.
   * @param [options] The optional parameters
   * @returns Promise<Models.AlertsGetAlertsResponse>
   */
  getAlerts(options?: Models.AlertsGetAlertsOptionalParams): Promise<Models.AlertsGetAlertsResponse>;
  /**
   * @param callback The callback
   */
  getAlerts(callback: coreHttp.ServiceCallback<Models.AlertsInfo>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getAlerts(options: Models.AlertsGetAlertsOptionalParams, callback: coreHttp.ServiceCallback<Models.AlertsInfo>): void;
  getAlerts(options?: Models.AlertsGetAlertsOptionalParams | coreHttp.ServiceCallback<Models.AlertsInfo>, callback?: coreHttp.ServiceCallback<Models.AlertsInfo>): Promise<Models.AlertsGetAlertsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getAlertsOperationSpec,
      callback) as Promise<Models.AlertsGetAlertsResponse>;
  }

  /**
   * Calls Alerts Manager to return active and not dismissed alerts for the current user and family
   * members based on the parameters.
   * @summary Retrieves active alerts and not dismissed alerts for the current user and family
   * members.
   * @param [options] The optional parameters
   * @returns Promise<Models.AlertsGetAlertsSummaryResponse>
   */
  getAlertsSummary(options?: Models.AlertsGetAlertsSummaryOptionalParams): Promise<Models.AlertsGetAlertsSummaryResponse>;
  /**
   * @param callback The callback
   */
  getAlertsSummary(callback: coreHttp.ServiceCallback<Models.AlertsInfo>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getAlertsSummary(options: Models.AlertsGetAlertsSummaryOptionalParams, callback: coreHttp.ServiceCallback<Models.AlertsInfo>): void;
  getAlertsSummary(options?: Models.AlertsGetAlertsSummaryOptionalParams | coreHttp.ServiceCallback<Models.AlertsInfo>, callback?: coreHttp.ServiceCallback<Models.AlertsInfo>): Promise<Models.AlertsGetAlertsSummaryResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getAlertsSummaryOperationSpec,
      callback) as Promise<Models.AlertsGetAlertsSummaryResponse>;
  }

  /**
   * Calls Alerts Manager to return the specific alert by its alertId.
   * @summary Retrieves the alert for the user by its alertId.
   * @param alertId
   * @param [options] The optional parameters
   * @returns Promise<Models.AlertsGetAlertResponse>
   */
  getAlert(alertId: string, options?: Models.AlertsGetAlertOptionalParams): Promise<Models.AlertsGetAlertResponse>;
  /**
   * @param alertId
   * @param callback The callback
   */
  getAlert(alertId: string, callback: coreHttp.ServiceCallback<Models.Alert>): void;
  /**
   * @param alertId
   * @param options The optional parameters
   * @param callback The callback
   */
  getAlert(alertId: string, options: Models.AlertsGetAlertOptionalParams, callback: coreHttp.ServiceCallback<Models.Alert>): void;
  getAlert(alertId: string, options?: Models.AlertsGetAlertOptionalParams | coreHttp.ServiceCallback<Models.Alert>, callback?: coreHttp.ServiceCallback<Models.Alert>): Promise<Models.AlertsGetAlertResponse> {
    return this.client.sendOperationRequest(
      {
        alertId,
        options
      },
      getAlertOperationSpec,
      callback) as Promise<Models.AlertsGetAlertResponse>;
  }

  /**
   * Calls Alerts Manager to update the specific alert using the given properties.
   * @summary Updates the alert for the user by its alertId using the update alert properties.
   * @param alertId
   * @param [options] The optional parameters
   * @returns Promise<Models.AlertsUpdateAlertMethodResponse>
   */
  updateAlertMethod(alertId: string, options?: Models.AlertsUpdateAlertMethodOptionalParams): Promise<Models.AlertsUpdateAlertMethodResponse>;
  /**
   * @param alertId
   * @param callback The callback
   */
  updateAlertMethod(alertId: string, callback: coreHttp.ServiceCallback<Models.Alert>): void;
  /**
   * @param alertId
   * @param options The optional parameters
   * @param callback The callback
   */
  updateAlertMethod(alertId: string, options: Models.AlertsUpdateAlertMethodOptionalParams, callback: coreHttp.ServiceCallback<Models.Alert>): void;
  updateAlertMethod(alertId: string, options?: Models.AlertsUpdateAlertMethodOptionalParams | coreHttp.ServiceCallback<Models.Alert>, callback?: coreHttp.ServiceCallback<Models.Alert>): Promise<Models.AlertsUpdateAlertMethodResponse> {
    return this.client.sendOperationRequest(
      {
        alertId,
        options
      },
      updateAlertMethodOperationSpec,
      callback) as Promise<Models.AlertsUpdateAlertMethodResponse>;
  }

  /**
   * Calls Consumer Security Alert Manager to remove the specified alert
   * @summary Delete the alert with provided alertId.
   * @param alertId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteAlert(alertId: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param alertId
   * @param callback The callback
   */
  deleteAlert(alertId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param alertId
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteAlert(alertId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  deleteAlert(alertId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        alertId,
        options
      },
      deleteAlertOperationSpec,
      callback);
  }

  /**
   * Calls Alerts Manager to return unsafe url alert's details by alertId.API can be used to get url,
   * category and timeline of unsafe url alert.
   * @summary Retrieves details for unsafe url alert details by alertId.
   * @param alertId
   * @param [options] The optional parameters
   * @returns Promise<Models.AlertsGetUnsafeUrlAlertDetailsResponse>
   */
  getUnsafeUrlAlertDetails(alertId: string, options?: Models.AlertsGetUnsafeUrlAlertDetailsOptionalParams): Promise<Models.AlertsGetUnsafeUrlAlertDetailsResponse>;
  /**
   * @param alertId
   * @param callback The callback
   */
  getUnsafeUrlAlertDetails(alertId: string, callback: coreHttp.ServiceCallback<Models.UnsafeUrlDetails>): void;
  /**
   * @param alertId
   * @param options The optional parameters
   * @param callback The callback
   */
  getUnsafeUrlAlertDetails(alertId: string, options: Models.AlertsGetUnsafeUrlAlertDetailsOptionalParams, callback: coreHttp.ServiceCallback<Models.UnsafeUrlDetails>): void;
  getUnsafeUrlAlertDetails(alertId: string, options?: Models.AlertsGetUnsafeUrlAlertDetailsOptionalParams | coreHttp.ServiceCallback<Models.UnsafeUrlDetails>, callback?: coreHttp.ServiceCallback<Models.UnsafeUrlDetails>): Promise<Models.AlertsGetUnsafeUrlAlertDetailsResponse> {
    return this.client.sendOperationRequest(
      {
        alertId,
        options
      },
      getUnsafeUrlAlertDetailsOperationSpec,
      callback) as Promise<Models.AlertsGetUnsafeUrlAlertDetailsResponse>;
  }

  /**
   * Calls Alerts Manager to return unsafe url alert's details by deviceId, url and detection
   * datetime.This API can be used to get timeline and threat details for unsafe url alerts on the
   * local device.
   * @summary Retrieves details for unsafe url alert details by unsafe url parameters.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<Models.AlertsGetUnsafeUrlAlertDetailsByParametersResponse>
   */
  getUnsafeUrlAlertDetailsByParameters(deviceId: string, options?: Models.AlertsGetUnsafeUrlAlertDetailsByParametersOptionalParams): Promise<Models.AlertsGetUnsafeUrlAlertDetailsByParametersResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  getUnsafeUrlAlertDetailsByParameters(deviceId: string, callback: coreHttp.ServiceCallback<Models.UnsafeUrlDetails>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  getUnsafeUrlAlertDetailsByParameters(deviceId: string, options: Models.AlertsGetUnsafeUrlAlertDetailsByParametersOptionalParams, callback: coreHttp.ServiceCallback<Models.UnsafeUrlDetails>): void;
  getUnsafeUrlAlertDetailsByParameters(deviceId: string, options?: Models.AlertsGetUnsafeUrlAlertDetailsByParametersOptionalParams | coreHttp.ServiceCallback<Models.UnsafeUrlDetails>, callback?: coreHttp.ServiceCallback<Models.UnsafeUrlDetails>): Promise<Models.AlertsGetUnsafeUrlAlertDetailsByParametersResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      getUnsafeUrlAlertDetailsByParametersOperationSpec,
      callback) as Promise<Models.AlertsGetUnsafeUrlAlertDetailsByParametersResponse>;
  }

  /**
   * Calls Alerts Manager to return threat alert's details by alert id.API can be used to get name,
   * category and timeline of the threat alert.
   * @summary Retrieves details for threat alert by alertId.
   * @param alertId
   * @param [options] The optional parameters
   * @returns Promise<Models.AlertsGetThreatAlertDetailsResponse>
   */
  getThreatAlertDetails(alertId: string, options?: Models.AlertsGetThreatAlertDetailsOptionalParams): Promise<Models.AlertsGetThreatAlertDetailsResponse>;
  /**
   * @param alertId
   * @param callback The callback
   */
  getThreatAlertDetails(alertId: string, callback: coreHttp.ServiceCallback<Models.ThreatDetails>): void;
  /**
   * @param alertId
   * @param options The optional parameters
   * @param callback The callback
   */
  getThreatAlertDetails(alertId: string, options: Models.AlertsGetThreatAlertDetailsOptionalParams, callback: coreHttp.ServiceCallback<Models.ThreatDetails>): void;
  getThreatAlertDetails(alertId: string, options?: Models.AlertsGetThreatAlertDetailsOptionalParams | coreHttp.ServiceCallback<Models.ThreatDetails>, callback?: coreHttp.ServiceCallback<Models.ThreatDetails>): Promise<Models.AlertsGetThreatAlertDetailsResponse> {
    return this.client.sendOperationRequest(
      {
        alertId,
        options
      },
      getThreatAlertDetailsOperationSpec,
      callback) as Promise<Models.AlertsGetThreatAlertDetailsResponse>;
  }

  /**
   * Calls Alerts Manager to return threat alert's details by device id and detection id.API can be
   * used to get name, category and timeline of the threat alert.This API can be used to get timeline
   * and threat details for local device alerts.
   * @summary Retrieves details for local device threat alert by deviceId and detectionId.
   * @param deviceId
   * @param detectionId
   * @param [options] The optional parameters
   * @returns Promise<Models.AlertsGetThreatAlertDetailsByDetectionIdResponse>
   */
  getThreatAlertDetailsByDetectionId(deviceId: string, detectionId: string, options?: coreHttp.RequestOptionsBase): Promise<Models.AlertsGetThreatAlertDetailsByDetectionIdResponse>;
  /**
   * @param deviceId
   * @param detectionId
   * @param callback The callback
   */
  getThreatAlertDetailsByDetectionId(deviceId: string, detectionId: string, callback: coreHttp.ServiceCallback<Models.ThreatDetails>): void;
  /**
   * @param deviceId
   * @param detectionId
   * @param options The optional parameters
   * @param callback The callback
   */
  getThreatAlertDetailsByDetectionId(deviceId: string, detectionId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.ThreatDetails>): void;
  getThreatAlertDetailsByDetectionId(deviceId: string, detectionId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.ThreatDetails>, callback?: coreHttp.ServiceCallback<Models.ThreatDetails>): Promise<Models.AlertsGetThreatAlertDetailsByDetectionIdResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        detectionId,
        options
      },
      getThreatAlertDetailsByDetectionIdOperationSpec,
      callback) as Promise<Models.AlertsGetThreatAlertDetailsByDetectionIdResponse>;
  }

  /**
   * Calls Alerts Manager to return setting type alert's details by alert id.API can be used to get
   * setting name, actions and timeline of the setting type alert.
   * @summary Retrieves details for setting type alert by alert id.
   * @param alertId
   * @param [options] The optional parameters
   * @returns Promise<Models.AlertsGetSettingAlertDetailsResponse>
   */
  getSettingAlertDetails(alertId: string, options?: Models.AlertsGetSettingAlertDetailsOptionalParams): Promise<Models.AlertsGetSettingAlertDetailsResponse>;
  /**
   * @param alertId
   * @param callback The callback
   */
  getSettingAlertDetails(alertId: string, callback: coreHttp.ServiceCallback<Models.SettingDetails>): void;
  /**
   * @param alertId
   * @param options The optional parameters
   * @param callback The callback
   */
  getSettingAlertDetails(alertId: string, options: Models.AlertsGetSettingAlertDetailsOptionalParams, callback: coreHttp.ServiceCallback<Models.SettingDetails>): void;
  getSettingAlertDetails(alertId: string, options?: Models.AlertsGetSettingAlertDetailsOptionalParams | coreHttp.ServiceCallback<Models.SettingDetails>, callback?: coreHttp.ServiceCallback<Models.SettingDetails>): Promise<Models.AlertsGetSettingAlertDetailsResponse> {
    return this.client.sendOperationRequest(
      {
        alertId,
        options
      },
      getSettingAlertDetailsOperationSpec,
      callback) as Promise<Models.AlertsGetSettingAlertDetailsResponse>;
  }

  /**
   * Calls Alerts Manager to return setting type alert's details by deviceId and setting type.API can
   * be used to get setting name, actions and timeline of the setting type alert.
   * @summary Retrieves details for local device setting type alert by deviceId and setting type.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<Models.AlertsGetSettingAlertDetailsByParametersResponse>
   */
  getSettingAlertDetailsByParameters(deviceId: string, options?: Models.AlertsGetSettingAlertDetailsByParametersOptionalParams): Promise<Models.AlertsGetSettingAlertDetailsByParametersResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  getSettingAlertDetailsByParameters(deviceId: string, callback: coreHttp.ServiceCallback<Models.SettingDetails>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  getSettingAlertDetailsByParameters(deviceId: string, options: Models.AlertsGetSettingAlertDetailsByParametersOptionalParams, callback: coreHttp.ServiceCallback<Models.SettingDetails>): void;
  getSettingAlertDetailsByParameters(deviceId: string, options?: Models.AlertsGetSettingAlertDetailsByParametersOptionalParams | coreHttp.ServiceCallback<Models.SettingDetails>, callback?: coreHttp.ServiceCallback<Models.SettingDetails>): Promise<Models.AlertsGetSettingAlertDetailsByParametersResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      getSettingAlertDetailsByParametersOperationSpec,
      callback) as Promise<Models.AlertsGetSettingAlertDetailsByParametersResponse>;
  }

  /**
   * Calls Alerts Manager to create a pending alert using the given properties.
   * @summary Creates a pending alert for the user using the given pending alert properties.
   * @param [options] The optional parameters
   * @returns Promise<Models.AlertsCreatePendingAlertResponse>
   */
  createPendingAlert(options?: Models.AlertsCreatePendingAlertOptionalParams): Promise<Models.AlertsCreatePendingAlertResponse>;
  /**
   * @param callback The callback
   */
  createPendingAlert(callback: coreHttp.ServiceCallback<Models.PendingAlert>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  createPendingAlert(options: Models.AlertsCreatePendingAlertOptionalParams, callback: coreHttp.ServiceCallback<Models.PendingAlert>): void;
  createPendingAlert(options?: Models.AlertsCreatePendingAlertOptionalParams | coreHttp.ServiceCallback<Models.PendingAlert>, callback?: coreHttp.ServiceCallback<Models.PendingAlert>): Promise<Models.AlertsCreatePendingAlertResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      createPendingAlertOperationSpec,
      callback) as Promise<Models.AlertsCreatePendingAlertResponse>;
  }

  /**
   * Calls Consumer Security Alert Manager to delete device alerts associated with provided device id
   * for the current user
   * @summary Delete device alerts associated with provided device id for the current user.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteDeviceAlerts(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  deleteDeviceAlerts(deviceId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteDeviceAlerts(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  deleteDeviceAlerts(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      deleteDeviceAlertsOperationSpec,
      callback);
  }

  /**
   * Calls Consumer Security Alert Manager to delete all alerts info for the current user
   * @summary Delete all alerts data for the current user.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteAllAlerts(options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  deleteAllAlerts(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteAllAlerts(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  deleteAllAlerts(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      deleteAllAlertsOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getAlertsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Alerts",
  queryParameters: [
    Parameters.includeFamily0,
    Parameters.localDeviceId,
    Parameters.userIds,
    Parameters.deviceIds,
    Parameters.breachIds,
    Parameters.creditMonitoringIds,
    Parameters.isActive,
    Parameters.isDismissed,
    Parameters.itmBreachesGrouping,
    Parameters.severity,
    Parameters.status,
    Parameters.alertTypes,
    Parameters.pageNumber,
    Parameters.pageSize
  ],
  responses: {
    200: {
      bodyMapper: Mappers.AlertsInfo
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getAlertsSummaryOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Alerts/summary",
  queryParameters: [
    Parameters.includeFamily0,
    Parameters.localDeviceId,
    Parameters.pageNumber,
    Parameters.pageSize,
    Parameters.itmBreachesGrouping,
    Parameters.alertTypes
  ],
  responses: {
    200: {
      bodyMapper: Mappers.AlertsInfo
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getAlertOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Alerts/{alertId}",
  urlParameters: [
    Parameters.alertId
  ],
  queryParameters: [
    Parameters.includeFamily0
  ],
  responses: {
    200: {
      bodyMapper: Mappers.Alert
    },
    404: {
      bodyMapper: Mappers.Alert
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateAlertMethodOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/Alerts/{alertId}",
  urlParameters: [
    Parameters.alertId
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UpdateAlert
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.Alert
    },
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteAlertOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/me/Alerts/{alertId}",
  urlParameters: [
    Parameters.alertId
  ],
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getUnsafeUrlAlertDetailsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Alerts/devices/unsafeUrls/{alertId}",
  urlParameters: [
    Parameters.alertId
  ],
  queryParameters: [
    Parameters.includeFamily0
  ],
  responses: {
    200: {
      bodyMapper: Mappers.UnsafeUrlDetails
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getUnsafeUrlAlertDetailsByParametersOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/Alerts/devices/{deviceId}/unsafeUrls",
  urlParameters: [
    Parameters.deviceId
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UnsafeUrlParameters
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.UnsafeUrlDetails
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getThreatAlertDetailsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Alerts/devices/threats/{alertId}",
  urlParameters: [
    Parameters.alertId
  ],
  queryParameters: [
    Parameters.includeFamily0
  ],
  responses: {
    200: {
      bodyMapper: Mappers.ThreatDetails
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getThreatAlertDetailsByDetectionIdOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Alerts/devices/{deviceId}/threats/{detectionId}",
  urlParameters: [
    Parameters.deviceId,
    Parameters.detectionId
  ],
  responses: {
    200: {
      bodyMapper: Mappers.ThreatDetails
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getSettingAlertDetailsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Alerts/devices/settings/{alertId}",
  urlParameters: [
    Parameters.alertId
  ],
  queryParameters: [
    Parameters.includeFamily0
  ],
  responses: {
    200: {
      bodyMapper: Mappers.SettingDetails
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getSettingAlertDetailsByParametersOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/Alerts/devices/{deviceId}/settings",
  urlParameters: [
    Parameters.deviceId
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ProtectionSettingParameters
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.SettingDetails
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const createPendingAlertOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/Alerts/detection",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.PendingAlert
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.PendingAlert
    },
    201: {
      bodyMapper: Mappers.PendingAlert
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteDeviceAlertsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/me/Alerts/devices/{deviceId}",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteAllAlertsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/me/Alerts/all",
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
